import { render } from "./AdminRoot.vue?vue&type=template&id=5f326cda&scoped=true"
import script from "./AdminRoot.vue?vue&type=script&lang=js"
export * from "./AdminRoot.vue?vue&type=script&lang=js"

import "./AdminRoot.vue?vue&type=style&index=0&id=5f326cda&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f326cda"]])

export default __exports__